// Macro #33 acceptance fix — localized legal bundle registry.
// One LegalBundle per supported locale; the Legal surfaces resolve the active
// locale's bundle at render time. English stays the canonical legal source.
import type { Locale } from "../config";
import { DEFAULT_LOCALE } from "../config";
import type { LegalBundle } from "./types";
import en from "./en";
import es from "./es";
import ptBr from "./pt-br";
import fr from "./fr";
import de from "./de";
import it from "./it";
import ru from "./ru";

export const LEGAL_BUNDLES: Record<Locale, LegalBundle> = {
  en,
  es,
  "pt-br": ptBr,
  fr,
  de,
  it,
  ru,
};

/** Resolve the legal bundle for a locale, falling back to English. */
export function getLegalBundle(locale: Locale): LegalBundle {
  return LEGAL_BUNDLES[locale] ?? LEGAL_BUNDLES[DEFAULT_LOCALE];
}

export { default as legalEn } from "./en";
export {
  LEGAL_DOC_ORDER,
  LEGAL_DOC_INDEX,
  type LegalDocId,
  type LegalBundle,
  type LegalDoc,
  type LegalSection,
} from "./types";
